/* globals $ */
import template from './template.html'

export default [
  '$rootScope',
  '$timeout',
  'afterNextClickService',
  'storyService',
  directive,
]

function directive($rootScope, $timeout, afterNextClickService, storyService) {
  return {
    restrict: 'E',
    template,
    replace: true,
    scope: {
      selected: '=',
      options: '<',
    },

    controller: [
      '$scope',
      function($scope) {
        const dflt = (a) => (a && a !== '' ? a : '__default')
        const hshr = (o, x) => {
          o[dflt(x.value)] = x
          return o
        }
        const undf = (a) => (a === '__default' ? undefined : a)

        const optionHash = $scope.options.slice().reduce(hshr, {})

        $scope.pick = (val, event) => {
          val = dflt(val)
          if (optionHash[val]) {
            $scope.selected = undf(val)
            $scope.icon = optionHash[val].icon
            $scope.iconActive =
              optionHash[val].iconActive || optionHash[val].icon

            if (event) {
              storyService.isDirty(true)
            }
          }
        }

        // sync with inbound value
        $scope.pick($scope.selected)

        $scope.$watch('selected', (newValue, oldValue) => {
          $scope.pick(newValue)
        })
      },
    ],

    link: function($scope, $el, $attrs) {
      const armDismiss = () =>
        afterNextClickService.afterNextClick(() => {
          $($el).popover('hide')
        })

      const bind = () => {
        const poptmpl = $el.find('.ellipsis-btn-select-options')[0]
        $($el)
          .popover({
            content: poptmpl,
            html: true,
            placement: 'top',
            trigger: 'manual',
          })
          // dismiss on next click, for actual real, bootsrap
          .on('show.bs.popover', armDismiss)
      }

      $scope.tooltipTitle = $attrs.title

      $timeout(bind)

      $scope.toggle = () => {
        $($el).popover('toggle')
      }
    },
  }
}
